<template>
  <div class="applydetail">
    <div class="applydetail-tip">
      <!-- 审核状态0 审核中 1已通过 2已驳回 -->
      <Alert show-icon v-if="form.status == 0" class="checkIng">审核中</Alert>
      <Alert type="success" show-icon v-if="form.status == 1">已通过</Alert>
      <div class="error">
        <Alert type="error" show-icon v-if="form.status == 2">
          已驳回
          <span class="tipRight">原因：{{ form.rejectCause || 暂无原因 }}</span>
        </Alert>
      </div>
    </div>
    <!-- /企业地址及详细信息 -->
    <div class="applydetail-btm mt-24">
      <div class="applydetail-btm-left">
        <div class="applydetail-itemp">
          <label for>企业名称：</label>
          <div>{{ companyAdress.name }}</div>
        </div>
        <div class="applydetail-itemp">
          <label for>统一社会信用代码：</label>
          <div>{{ companyAdress.creditCode }}</div>
        </div>
        <div class="applydetail-itemp" v-if="companyAdress.type == 0">
          <label for>经营限制：</label>
          <div>{{ operatingPeriod() }}</div>
        </div>
        <div class="applydetail-itemp">
          <label for>所在地：</label>
          <div>
            {{ companyAdress.provinceName }}
            {{ companyAdress.cityName }}
            {{ companyAdress.districtName }}
            {{ companyAdress.address }}
          </div>
        </div>
        <div class="applydetail-itemp">
          <label for>法定代表人姓名：</label>
          <div>{{ companyAdress.legal }}</div>
        </div>
        <div class="applydetail-itemp">
          <label for>所选资源：</label>
          <div>
            <span @click="seeTree" class="fontblue fontcursor">数量{{ form.number }}</span>
          </div>
        </div>
        <div class="applydetail-itemp">
          <label for>申请人：</label>
          <div>{{ form.applyPersonName }}</div>
        </div>
        <div class="applydetail-itemp">
          <label for>联系电话：</label>
          <div>{{ form.applyPersonPhone }}</div>
        </div>
        <div class="applydetail-itemp">
          <label for>联系地址：</label>
          <div>{{ form.applyPersonAddress }}</div>
        </div>
        <div class="applydetail-itemp">
          <label for>联系邮箱：</label>
          <div>{{ form.applyPersonEmail }}</div>
        </div>
        <div class="applydetail-itemp">
          <label for>使用场景：</label>
          <div>{{ form.scenario }}</div>
        </div>
        <div class="applydetail-itemp">
          <label for>证明材料：</label>
          <div
            v-if="
              form &&
              form.examineAdjunct &&
              form.examineAdjunct.length &&
              form.examineAdjunct[0] != ''
            "
          >
            <p class="mb-8" v-for="(item, index) in form.examineAdjunct" :key="index">
              <i class="icon tsit icon_fujian"></i>
              <!-- 对字符串进行截取，保留图片以及名称 -->
              <span @click="previewPicture(item)">
                {{
                item.substring(item.lastIndexOf("*") + 1, item.length)
                }}
              </span>
              <!-- 文件时在本窗口打开 -->
              <a
                v-if="
                  item.substring(item.lastIndexOf('.') + 1) == 'pdf' ||
                  item.substring(item.lastIndexOf('.') + 1) == 'doc' ||
                  item.substring(item.lastIndexOf('.') + 1) == 'docx' ||
                  item.substring(item.lastIndexOf('.') + 1) == 'xls' ||
                  item.substring(item.lastIndexOf('.') + 1) == 'xlsx'
                "
                class="fontblue"
                target="_self"
                rel="noopener noreferrer"
                :href="item.substring(0, item.lastIndexOf('*'))"
              >
                <i class="icon tsit icon_xiazai ml-16"></i>下载
              </a>
              <!-- 图片时时在新窗口打开 -->
              <a
                v-else
                class="fontblue"
                target="_blank"
                rel="noopener noreferrer"
                :href="item.substring(0, item.lastIndexOf('*'))"
              >
                <i class="icon tsit icon_xiazai ml-16"></i>下载
              </a>
            </p>
          </div>
          <p v-else>暂无数据</p>
        </div>
        <div class="applydetail-itemp">
          <label for>其他补充：</label>
          <div>{{ form.remark || "暂无数据" }}</div>
        </div>
        <div class="ml-64">
          <p class="returnBtn">
            <!-- 审核通过 -->
            <Poptip
              class="poptip"
              confirm
              transfer
              placement="top"
              @on-ok="checkPass"
              @on-cancel="cancelCheckPass"
              title="确认通过审核吗？"
            >
              <Button class="btn1" type="primary" v-if="form.status == 0">审核通过</Button>
            </Poptip>
            <!-- 审核驳回 -->
            <Button class="btn2" type="error" v-if="form.status == 0" @click="seeEdit">驳回</Button>
            <Button class="btn" @click="link('/video/videoapproval')">返回</Button>
          </p>
        </div>
      </div>
      <!-- 0 审批中 1通过 2驳回 3 已撤回 -->
      <div class="applydetail-btm-right" v-if="commitList && commitList.length">
        <div class="top"></div>
        <div class="commitlist">
          <div class="commititem mb-16" v-for="(item, index) in commitList" :key="index">
            <div class="flexsb">
              <div>
                <p v-if="item.status != 2">第{{ item.submitMsg }}次提交</p>
                <p v-if="item.status == 2">已驳回</p>
                <p class="mt-4">{{ item.createTime || "暂无" }}</p>
              </div>
              <div>
                <img src="@/assets/img/video/commit_item.png" alt />
              </div>
            </div>
            <div
              v-if="item.status == 2"
              class="reason lineBreak mt-16 pt-16"
            >原因：{{ item.rejectCause || "无原因" }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 所选资源详情 -->
    <resourceDetail :dialog.sync="showDetail" :detail="rowData" v-if="showDetail" />
    <!-- 驳回原因 -->
    <applyDown
      v-if="showEdit"
      @close="showEdit = false"
      @confirm="showEdit = false"
      :form="propForm"
    />
    <SelectResource
      v-if="SelectResourceShow"
      @SelectResourceClose="SelectResourceShow = false"
      @SelectResourceResult="SelectResourceResult"
      :id="id + ''"
      :userType="type"
      :totalNum="form.number"
    ></SelectResource>
    <!-- 预览大图 -->
    <previewImage v-if="preViewModal" v-model="preViewModal" :preView="preView" />
    <!-- 预览文件 -->
    <PreviewFile v-if="showFile" :url="fileUrl" @close="showFile = false" />
  </div>
</template>

<script>
import { approvalDetail, approvalPass } from "@/api/resource";
import resourceDetail from "@/components/apply-resource-list-v1/resourceDetail.vue";
import applyDown from "../components/ApplyDown";
import SelectResource from "@/components/apply-resource-tree-v2/select-resource.vue";
import previewImage from "@/components/previewImage"; //预览大图组件
import PreviewFile from "@/components/dialog/preview-file.vue"; //预览文件组件

export default {
  name: "",
  components: {
    resourceDetail,
    applyDown,
    SelectResource,
    previewImage,
    PreviewFile
  },
  data() {
    return {
      showFile: false,
      fileUrl: "",
      form: {},
      companyAdress: [], //新增企业信息
      id: -1,
      loading: false,
      delLoad: false,
      showDetail: false,
      commitList: [],
      dataList: [],
      rowData: {},
      //预览大图
      preViewModal: false, //预览弹窗
      preView: {
        imgSrc: "", //预览图片路径
        title: "" //预览图片标题
      },
      showEdit: false,
      SelectResourceShow: false
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.getInfo();
  },
  computed: {},
  methods: {
    previewPicture(item) {
      let url = item.substring(0, item.lastIndexOf("*")); //正常文件路径
      // let flag = this.isImg(url.substring(url.lastIndexOf("."))); //是否是图片
      let name = item.substring(item.lastIndexOf("*") + 1, item.length); //文件名字
      let suffix = _Util.matchFileSuffixType(name);
      // 如果是图片
      if (suffix == "image") {
        this.preView.title = name;
        this.preView.imgSrc = url;
        this.preViewModal = true;
      } else {
        this.fileUrl = url;
        this.showFile = true;
      }
    },
    seeTree() {
      this.SelectResourceShow = true;
    },
    //返回选择的资源和数量
    SelectResourceResult(sources, num) {
      this.SelectResourceShow = false;
    },
    // 资源审批详情
    getInfo() {
      approvalDetail(this.id, this.type).then(res => {
        console.log(res, "资源审批详情");
        this.form = res.data.data.resource;
        this.commitList = res.data.data.historyList;
        this.dataList = res.data.data.resourceDetailDtoList;
        this.companyAdress = res.data.data.company;
      });
    },
    //经营期限的转换
    operatingPeriod() {
      if (this.companyAdress.isLongTerm == 1) {
        return "长期";
      } else {
        if (this.companyAdress.isLongTerm == 0) {
          if (this.companyAdress.operatingPeriodBegin) {
            return (
              this.companyAdress.operatingPeriodBegin.split(" ")[0] +
              "至" +
              this.companyAdress.operatingPeriodEnd.split(" ")[0]
            );
          } else {
            return "无开始日期";
          }
        }
      }
    },
    //驳回操作
    seeEdit() {
      this.propForm = {
        id: this.id,
        type: this.type
      };
      this.showEdit = true;
    },
    // 所选资源详情
    seeDetail(row) {
      this.showDetail = true;
      this.rowData = JSON.parse(JSON.stringify(row));
    },
    // 资源审核通过
    checkPass() {
      approvalPass(this.id, this.type)
        .then(res => {
          console.log("res", res);
          this.$Message.success("资源审核通过");
          this.$router.push({ path: "/video/videoapproval" });
        })
        .catch(err => {
          console.log(err, "err");
        });
    },
    //资源审核取消
    cancelCheckPass() {
      console.log("点击了取消按钮");
    },
    //页面跳转
    link(path, type) {
      if (type) {
        this.$router.push({
          path: path,
          query: {
            id: this.form.id,
            type: type
          }
        });
      } else {
        this.$router.push({
          path: path
        });
      }
    }
  }
};
</script>

<style lang="scss">
.applydetail {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 24px 32px;
  overflow: auto;
  .updateTxtAdress {
    padding: 5px 0;
    div {
      padding: 5px 0;
      color: #67799c;
      span {
        color: #515a6e;
      }
    }
  }
  &-tip {
    .ivu-alert {
      color: rgb(140, 230, 176);
    }
    .error {
      .ivu-alert {
        color: rgb(237, 64, 20);
      }
    }
    .tipRight {
      margin-left: 30px;
      width: 100%;
      word-break: break-all;
    }
    .checkIng {
      background-color: #d4e3fd;
      border-color: #568bf7;
      color: #568bf7;
      .ivu-alert-icon {
        margin-top: 2px;
      }
    }
  }
  &-btm {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: calc(100% - 70px);
    &-left {
      width: calc(100% - 380px);
      height: 100%;
      .returnBtn {
        display: flex;
        .btn {
          width: 104px;
          height: 36px;
          background: #ffffff;
          border-radius: 18px;
          border: 1px solid #dcdfe6;
          margin-left: 20px;
          flex-shrink: 0;
        }
        .btn1,
        .btn2 {
          width: 104px;
          height: 36px;
          border-radius: 18px;
          margin-left: 20px;
          flex-shrink: 0;
        }
        .btn1 {
          margin-left: 0px;
        }
      }
    }
    &-right {
      width: 364px;
      height: 100%;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      > .top {
        height: 118px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #dcdfe6;
        padding: 24px;
        background-image: url("~@/assets/img/video/commit_img.png");
        background-repeat: no-repeat;
        background-size: 100%;
        .line {
          width: 32px;
          height: 2px;
          background: #3c8aff;
        }
      }
      > .commitlist {
        padding: 16px 24px;
        height: calc(100% - 118px);
        overflow: auto;
        .commititem {
          width: 100%;
          padding: 12px 24px;
          background: rgba(220, 223, 230, 0.1);
          border: 1px dashed #dcdfe6;
          border-radius: 4px;
          .reason {
            border-top: 1px solid rgba(246, 247, 249, 1);
          }
        }
      }
      > .commitlist div:last-child {
        margin-bottom: 0px;
      }
    }
  }
  &-itemp {
    margin: 24px 0;
    display: flex;
    > label {
      width: 9em;
      text-align: right;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #67799c;
    }
    > div {
      flex: 1;
      word-break: break-all;
    }
  }
  //空格代表后代选择器
  .applydetail-btm-left :first-child {
    margin-top: 0px;
  }
}
</style>
